import { render } from "./Loading.vue.js?vue&type=template&id=08b05096!=!../vue-loader/dist/index.js??ruleSet[0]!./Loading.vue?vue&type=template&id=08b05096"
import script from "./Loading.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__